export const getDiscountInitialValues = () => {
  return {
    discountType: "",
    paymentCommitment: null,
    discount: "",
    discountForm: "",
    reason: "",
  }
}
